import React, { useEffect } from 'react';
import { useStateSelector } from '../../store/selectors';
import Rodal from '../Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { GetBuyer } from '../../slices/marketplace/buyer/thunks/get-buyer.thunk';
import './BuyerProfilePreviewPopup.scss';
import Loader from 'react-loaders';
import { ProfilePreview } from '../../containers/Admin/BuyerMarketplace/BuyerProfile/ProfilePreview/ProfilePreview';

interface BuyerProfilePreviewPopupProps {
    buyerId: number;
    close(): void;
}

const BuyerProfilePreviewPopup = (props: BuyerProfilePreviewPopupProps) => {
    const isLoading = useStateSelector((s) => s.buyersState.isLoading);

    const dispatch = useDispatch() as any;
    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        await dispatch(GetBuyer(props.buyerId));
    };

    return (
        <div className="buyer-profile-preview-popup">
            <Rodal
                visible={true}
                onClose={() => {
                    props.close();
                }}
                width={1200}
                animation={'fade'}
                showMask={true}
                centered>
                <ModalHeader className="modal-title">
                    {'Buyer Profile'}
                </ModalHeader>
                <ModalBody>
                    {isLoading ? (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '200px',
                            }}>
                            <Loader
                                active={isLoading}
                                type="ball-scale-multiple"
                            />
                        </div>
                    ) : (
                        <ProfilePreview isReadonly={true} />
                    )}
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default BuyerProfilePreviewPopup;
